import React, { ReactNode, useEffect } from 'react';
import { APP_ENVIRONMENT } from 'common/config/app';
import { useCookieConsent } from 'common/providers/CookieConsentProvider';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { initPostHog, stopPostHog } from 'scalarAnalytics/postHog';

interface AnalyticsProviderProps {
  children: ReactNode;
}

const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  const [{ user }] = useStore() as unknown as UseStoreValues;
  const { consent } = useCookieConsent();

  // In local development, default analytics on so PostHog session replay / heatmaps work
  // without setting the consent cookie. In staging/production, require analytics consent.
  const isLocalDev = APP_ENVIRONMENT === 'development';
  const isAnalyticsEnabled = isLocalDev || consent?.analytics !== false;

  useEffect(() => {
    if (isAnalyticsEnabled) {
      initPostHog(user ?? null);
    } else {
      stopPostHog();
    }
  }, [user, isAnalyticsEnabled]);

  return <span>{children}</span>;
};

export default AnalyticsProvider;
